'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionCarousel = function CollectionCarousel(el) {
  (0, _classCallCheck3.default)(this, CollectionCarousel);

  var carousel = (0, _functional.getElement)('[data-module="collection-carousel"]');
  var flkty = new _flickity2.default(carousel, {
    cellAlign: 'left',
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: false,
    touchVerticalScroll: false,
    dragThreshold: 50
  });

  flkty.on('dragStart.el', function (event, pointer) {
    document.ontouchmove = function (e) {
      e.preventDefault();
    };
  });

  flkty.on('dragEnd.flickity', function (event, pointer) {
    document.ontouchmove = function (e) {
      return true;
    };
  });

  // Setup custom buttons
  var previousButton = document.querySelector('.clc-Controls_Previous');
  previousButton.addEventListener('click', function () {
    flkty.previous();
  });

  var nextButton = document.querySelector('.clc-Controls_Next');
  nextButton.addEventListener('click', function () {
    flkty.next();
  });
};

exports.default = CollectionCarousel;